import React from 'react';

export default class NoMatch extends React.Component{
    render(){
        return(
            <h1>404 page not found</h1>
        )
    }
}